import 'flowbite/dist/flowbite.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store, persistor } from "./redux/store.js";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from 'react-toastify';
import 'flowbite';
import { Toaster } from 'sonner';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <PersistGate persistor={persistor}>
    <Provider store={store}>
      <React.StrictMode>
      <Toaster position="top-center" richColors closeButton />
        <ToastContainer/>
        <App />
      </React.StrictMode>
    </Provider>
  </PersistGate>
);


reportWebVitals();
